import { render, staticRenderFns } from "./TrancheInvestForm.vue?vue&type=template&id=30af66ec&scoped=true&"
import script from "./TrancheInvestForm.vue?vue&type=script&lang=js&"
export * from "./TrancheInvestForm.vue?vue&type=script&lang=js&"
import style0 from "./TrancheInvestForm.vue?vue&type=style&index=0&id=30af66ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30af66ec",
  null
  
)

export default component.exports